<template>
  <div v-if="!isLoading && contentType === 'onair' && (isError || !hasVodList)" class="vod-list-empty">
    <img src="../../assets/images/common/icon-error-74.png" alt="error">
    <p>본 프로그램은 Quick VOD만 제공됩니다.</p>
  </div>
  <div v-else-if="!isLoading && hasVodList" class="player-component01">
    <!-- 전체회차 -->
    <div id="all" class="player-list">
      <!-- select box -->
      <div class="filter-wrap">
        <!-- 시즌 선택 -->
        <vod-filter-list :filter="filter" />
        <!-- 콘텐츠 정렬 -->
        <div class="filter-item">
          <span>
            <label>
              <select v-model="orderData">
                <option value="new">최신회부터</option>
                <option value="old">첫회부터</option>
             </select>
            </label>
          </span>
        </div>
      </div>
      <!-- 전체회차 썸네일 리스트 -->
      <thumb-all-vod v-for="(thumb, index) in vodList"
                     :key="index"
                     :thumb="thumb"
                     :external-content-id="contentInfo.contentid"
                     :change-content="changeContent"
                     :is-pooqzone="isPooqzone"
                     :thumbnail-info="thumbnailInfo"
      />
    </div>
    <!-- 페이징 -->
    <paging-component :current-page="currentPage"
                      :page-count="pageCount"
                      :limit="limit"
                      :paging-count="10"
                      :is-next-button-view="isNextButtonView"
                      />
  </div>
</template>
<script>
import _ from 'lodash'
import ThumbAllVod from '@/components/model/ThumbAllVod'
import PagingComponent from '@/components/common/PagingComponent'
import { getVodContentsDetail, getVodProgramsContentid, getVodProgramsContents } from '@/common/utils/request'
import cookie from '@/common/utils/cookie'
import { parseUrl, stringify } from 'query-string'
import { contentDetailErrorCatcher, getThumbnailInfo, scrollTop } from '@/common/utils/common'
import axios from 'axios'
import VodFilterList from '@/pages/list/VodFilterList'
import { CHANGE_FILTER } from '@/common/resources/const'
export default {
  components: {
    ThumbAllVod,
    PagingComponent,
    VodFilterList
  },
  props: {
    contentInfo: {
      type: Object,
      required: true
    },
    order: {
      type: String
    }
  },
  data () {
    return {
      vodList: [],
      isPooqzone: cookie.isWavveOn(),
      currentPage: 1,
      pageCount: 0,
      limit: 10,
      isError: false,
      orderData: this.order,
      isNextButtonView: false,
      isPrevButtonView: false,
      isLoading: true,
      filter: null,
      programId: _.get(this.contentInfo, 'programid', ''),
      episodeSeasonFilterProgramId: _.get(this.$route, 'query.episodeseasonfilterprogramid', ''),
      thumbnailInfo: {}
    }
  },
  computed: {
    contentType () {
      return _.get(this.contentInfo, 'type', '')
    },
    hasVodList () {
      return this.vodList.length !== 0
    },
    page () {
      return Number(_.get(this.$route, ['query', 'page'], '1'))
    }
  },
  methods: {
    // 전체 BROADCAST 데이터를 API로 가져온다.
    callApi (page) {
      this.isLoading = true
      const offset = this.limit * (page - 1)
      if (this.episodeSeasonFilterProgramId !== '') this.programId = this.episodeSeasonFilterProgramId
      const nextContentsInfo = getVodProgramsContents({ programid: this.programId, offset: Math.ceil(page / 10) * 100, limit: this.limit, orderby: this.orderData })
      const ContentsListInfo = getVodProgramsContents({ programid: this.programId, offset, limit: this.limit, orderby: this.orderData })
      axios.all([ContentsListInfo, nextContentsInfo]).then(axios.spread((contentsRes, nextContentsRes) => {
       const listCount = _.get(nextContentsRes, 'data.cell_toplist.celllist', []).length
       this.isNextButtonView = listCount > 0
       this.vodList = _.get(contentsRes, 'data.cell_toplist.celllist', [])
       this.pageCount = Number(_.get(contentsRes, 'data.cell_toplist.pagecount', '0'))
       this.filter = _.get(contentsRes, 'data.filter', {})
       this.thumbnailInfo = getThumbnailInfo(_.get(contentsRes, 'data.cell_toplist.cell_type', ''))
       this.isLoading = false
       this.currentPage = page
        this.$nextTick(() => {
          scrollTop()
        })
      }))
    },
    changeContent (thumb) {
      const contentId = _.get(thumb, 'contentid', '')
      getVodContentsDetail({ contentid: contentId }).then(({ data }) => {
        const newQuery = {
          contentid: _.get(thumb, 'contentid', ''),
          page: this.currentPage,
          programid: _.get(thumb, 'programid', ''),
          order: this.orderData,
          onair: _.get(data, 'type', 'genenral') === 'onair' ? 'y' : 'n'
        }
        const { query } = parseUrl(location.href)
        const getProgramId = obj => _.get(obj, 'programid', '')
        const getContentId = obj => _.get(obj, 'contentid', '')
        const sameProgramId = getProgramId(thumb) === getProgramId(query)
        const sameContentId = getContentId(thumb) === getContentId(query)
        if (sameProgramId && sameContentId) { scrollTop(); return }
        this.$router.replace(`vod?${stringify(newQuery)}`)
      })
    },
    changedQueryRouterReplace (changedQueryObj) {
      const currentQuery = _.get(this.$route, 'query', {})
      const newQuery = _.assign({}, currentQuery, changedQueryObj)
      this.$router.replace(`vod?${stringify(newQuery)}`)
    }
  },
  created () {
    this.currentPage = Number(_.get(this.$route, ['query', 'page'], '1'))
    this.$events.$on(CHANGE_FILTER, (baseApi) => {
      const { url, query } = parseUrl(baseApi)
      this.episodeSeasonFilterProgramId = url.split('/').pop()
      this.limit = Number(_.get(query, 'limit', 10))
      this.offset = Number(_.get(query, 'offset', 0))
      getVodProgramsContentid({ programid: this.episodeSeasonFilterProgramId }).then(({ data }) => {
        this.contentId = _.get(data, 'contentid', '')
        getVodContentsDetail({ contentid: this.contentId }).then(({ data }) => {
          this.orderData = _.get(data, 'episodeorder', 'new')
          this.changedQueryRouterReplace({ order: this.orderData, page: '1', episodeseasonfilterprogramid: this.episodeSeasonFilterProgramId })
        }).catch(contentDetailErrorCatcher.bind(this))
      }).catch(() => {
        this.changedQueryRouterReplace({ page: '1', episodeseasonfilterprogramid: this.episodeSeasonFilterProgramId })
      })
    })
  },
  mounted () {
    this.callApi(this.currentPage)
  },
  watch: {
    orderData () {
      this.changedQueryRouterReplace({ order: this.orderData, page: '1' })
    }
  },
  beforeDestroy () {
    this.$events.$off(CHANGE_FILTER)
  }
}
</script>
